import { formatBRL } from "~/shared/ui/format";

// Wrapper de compatibilidade (spec §2.3): nulo continua virando R$ 0,00 como antes.
export const numberToBRL = (number) => formatBRL(Number(number) || 0);
